var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoPersonsActive = function SvgTwoPersonsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36.001,
    fill: "#262525",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.478 17.5c2.219 0 4.034-1.8 4.034-4s-1.815-4-4.034-4-4.034 1.8-4.034 4 1.815 4 4.034 4m4.538-.9c1.715 1.4 4.236 1.1 5.648-.6s1.109-4.2-.606-5.6c-.705-.6-1.613-.9-2.52-.9-.908 0-1.816.3-2.522.9 1.715 1.4 2.017 3.8.605 5.6-.1.2-.403.4-.605.6M29 25.4c-.605-3.7-3.731-6.4-7.463-6.4-.907 0-1.714.1-2.52.4 2.621.9 4.537 3.2 4.94 5.9.101.5-.302 1.1-.907 1.1h-.1 5.041c.606 0 1.009-.4 1.009-1M14.478 19c-3.731 0-6.958 2.7-7.463 6.4-.1.5.303 1.1.908 1.1h13.01c.604 0 1.008-.4 1.008-1v-.1c-.505-3.7-3.732-6.4-7.463-6.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C62F0",
    d: "M6 36a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3z"
  })));
};
export default SvgTwoPersonsActive;